import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "baseline",
        color: "#353535",
        letterSpacing: 0,
    },

    mobile_container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        color: "#353535",
        letterSpacing: 0,
    },

    leftText: {
        fontSize: "16px",
    },

    mobile_leftText: {
        fontSize: "14px",
    },

    percentage_red: {
        fontSize: "32px",
        color: "#E11919",
        margin: "0px 8px",
    },

    mobile_percentage_red: {
        fontSize: "32px",
        color: "#E11919",
        margin: "0px 8px",
        minWidth: "150px",
    },

    percentage_green: {
        fontSize: "32px",
        color: "#00833E",
        margin: "0px 8px",
    },

    mobile_percentage_green: {
        fontSize: "32px",
        color: "#00833E",
        margin: "0px 8px",
        minWidth: "150px",
    },

    sign: {
        fontSize: "16px",
    },

    mobile_sign: {
        fontSize: "20px",
    },

    smallText: {
        fontSize: "14px",
        margin: "0px 4px",
    },
}));

export default useStyles;
